import StoryboardSkeletons from "@/components/storyboard/StoryboardSkeletons";
import { mapStoryboardElementsToTrackedContentElements } from "@/components/storyboard/utils/mapStoryboardElementsToTrackedContentElements";
import type { CourseTreeNode } from "@/types/generated";
import type { Storyboard } from "@/types/storyboard";

const TrackedContentElementList = ({
  elements,
}: {
  elements: React.ReactNode[];
}) => {
  return <div className="space-y-16">{elements}</div>;
};

const EmptyState = () => (
  <p className="text-muted-foreground">Keine Inhalte verfügbar</p>
);

const StoryboardList = ({
  loading,
  storyboards,
  selectedContentElements,
}: {
  loading: boolean;
  storyboards: Storyboard[];
  selectedContentElements: CourseTreeNode[];
}) => {
  const trackedContentElements = mapStoryboardElementsToTrackedContentElements(
    storyboards,
    selectedContentElements
  );

  if (loading) return <StoryboardSkeletons />;

  if (!storyboards.length) {
    return <EmptyState />;
  }

  return <TrackedContentElementList elements={trackedContentElements} />;
};

export default StoryboardList;
